import { useContext } from "react";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import StartView from "./views/StartView";
import GameView from "./views/GameView";
import GameMobileView from "./views/GameMobileView";
import ResultView from "./views/ResultView";
import useResponsive from "./hooks/useResponsive";
import { GameContext } from "./context/GameContext";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";
import "./App.scss";

const theme = createTheme();

function App() {
  const { Mobile, Default } = useResponsive();
  const { view } = useContext(GameContext);

  const renderSwitch = (param) => {
    switch (param) {
      case "start":
        return <StartView />;
      case "game":
        return (
          <>
            <Default>
              <GameView />
            </Default>
            <Mobile>
              <GameMobileView />
            </Mobile>
          </>
        );
      case "result":
        return <ResultView />;
      default:
        return null;
    }
  };
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Header />
        {renderSwitch(view)}
        <Footer />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
